<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-membership-search-criteria
                [searchForm]="searchForm"
            ></app-membership-search-criteria>
        </div>
        <div class="col">
            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div
                    class="list-group list-group-flush"
                    infinite-scroll
                    [infiniteScrollDistance]="0.1"
                    [infiniteScrollThrottle]="300"
                    [infiniteScrollDisabled]="isBusy"
                    (scrolled)="onScroll()"
                >
                    @for (item of items; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start clickable"
                        >
                            <app-membership-list-row
                                (removeNoLimitRequested)="
                                    onRemoveNoLimit($event)
                                "
                                (addNoLimitRequested)="onAddNoLimit($event)"
                                [item]="item"
                            ></app-membership-list-row>
                        </div>
                    }
                    @if (noItems && !isBusy) {
                        <div class="no-items-info padding-20">
                            <span>{{
                                "MembershipList.NoItems" | translate
                            }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
